import {Component, computed, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {createComponentModalName, createComponentModalTitle} from "./configs/create-component-config";
import {MatButton} from "@angular/material/button";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {CreateComponentData, CreateComponentDialogData, CreateComponentForm} from "./types/create-component.types";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {createComponentFormFields} from "./configs/create-component-form-fields";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {PhoneMaskDirective} from "../../../../../../shared/directives/phone-mask.directive";
import {EmailMaskDirective} from "../../../../../../shared/directives/email-mask.directive";
import {CreateComponentService} from "./services/create-component.service";

@Component({
  selector: 'app-create-component-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    PhoneMaskDirective,
    EmailMaskDirective
  ],
  templateUrl: './create-component-modal.component.html',
  styleUrl: './create-component-modal.component.scss'
})
export class CreateComponentModalComponent extends BaseModalComponent {
  private createTestingResultDialogData = inject<CreateComponentDialogData>(MAT_DIALOG_DATA);
  private createComponentService: CreateComponentService = inject(CreateComponentService);

  public readonly createComponentModalTitle = createComponentModalTitle;
  public readonly createComponentFormFields = createComponentFormFields;
  public productCardId = computed(() => this.createTestingResultDialogData.productCardId);
  public componentForm: FormGroup = new FormGroup({});

  public override ngOnInit(): void  {
    super.ngOnInit();
    this.modalStatesService.openModal(createComponentModalName);
    this.componentForm = this.baseModalService.getFormGroup<CreateComponentForm>(createComponentFormFields);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(createComponentModalName);
  }

  public async handleCreate(): Promise<void> {
    const createData: CreateComponentData = {
      productCardId: this.productCardId(),
      ...this.componentForm.value
    };

    await this.createComponentService.createComponentData(createData)
      .then(() => this.closeDialog('success'))
      .catch(() => this.closeDialog('cancel'));
  }
}
